/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Finalcta_CtaInputs */

const tr_landing_finalcta_cta = /** @type {(inputs: Landing_Finalcta_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlayın`)
};

const en_landing_finalcta_cta = /** @type {(inputs: Landing_Finalcta_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Started`)
};

const de_landing_finalcta_cta = /** @type {(inputs: Landing_Finalcta_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt starten`)
};

const ru_landing_finalcta_cta = /** @type {(inputs: Landing_Finalcta_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начать`)
};

/**
* | output |
* | --- |
* | "Get Started" |
*
* @param {Landing_Finalcta_CtaInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_finalcta_cta = /** @type {((inputs?: Landing_Finalcta_CtaInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Finalcta_CtaInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_finalcta_cta(inputs)
	if (locale === "de") return de_landing_finalcta_cta(inputs)
	if (locale === "ru") return ru_landing_finalcta_cta(inputs)
	return tr_landing_finalcta_cta(inputs)
});